
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateCalculationTemplateVariableDtoFormGroup() {
return new FormGroup({
    variableKey: new FormControl<string | undefined>('', [Validators.maxLength(100), Validators.pattern(new RegExp("^[a-zA-Z][a-zA-Z0-9_]*$", ""))]),
    label: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    unitLabel: new FormControl<string | undefined>(undefined, [Validators.maxLength(50)]),
    description: new FormControl<string | undefined>(undefined, [Validators.maxLength(500)]),
    defaultValue: new FormControl<number | undefined>(undefined),
    sortOrder: new FormControl<number | undefined>(undefined),
})
;
}
      